import { render, staticRenderFns } from "./workAdministrator.vue?vue&type=template&id=edcf57e6"
import script from "./workAdministrator.vue?vue&type=script&lang=js"
export * from "./workAdministrator.vue?vue&type=script&lang=js"
import style0 from "./workAdministrator.vue?vue&type=style&index=0&id=edcf57e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports